// Excel Template Mock Actions
import { 
  getTemplatesByType, 
  getTemplateById, 
  getPresetByName,
  paginateTemplates,
  addMockTemplate,
  updateMockTemplate,
  deleteMockTemplate,
  bulkDeleteMockTemplates,
  createMockResponse,
  MOCK_CONFIG
} from '@/store/mockData/index.js';

const mockActions = {
  // 특정 프리셋 상세 조회
  async getExcelPresetDetail({ commit }, presetName) {
    try {
      console.log(`[MOCK] 프리셋 상세 조회: ${presetName}`);
      
      const preset = getPresetByName(presetName);
      if (!preset) {
        throw new Error(`Preset '${presetName}' not found`);
      }
      
      return await createMockResponse(preset);
    } catch (e) {
      console.log("[MOCK] 엑셀 프리셋 상세 조회 실패:", e);
      throw e;
    }
  },

  // 커스텀 엑셀 양식 목록 조회 (프리셋 포함)
  async getCustomExcelTemplates({ commit }, params) {
    try {
      console.log(`[MOCK] 엑셀 양식 목록 조회:`, params);
      
      const { 
        type = "all", 
        offset = MOCK_CONFIG.DEFAULT_OFFSET, 
        limit = MOCK_CONFIG.DEFAULT_LIMIT 
      } = params;
      
      // type에 따라 데이터 필터링
      const allData = getTemplatesByType(type);
      
      const paginatedResult = paginateTemplates(allData, offset, limit);
      
      return await createMockResponse(paginatedResult);
    } catch (e) {
      console.log("[MOCK] 커스텀 엑셀 양식 조회 실패:", e);
      throw e;
    }
  },

  // 커스텀 엑셀 양식 상세 조회
  async getCustomExcelTemplateDetail({ commit }, customSettingId) {
    try {
      console.log(`[MOCK] 엑셀 양식 상세 조회: ${customSettingId}`);
      
      const template = getTemplateById(customSettingId);
      if (!template) {
        throw new Error(`Template with ID '${customSettingId}' not found`);
      }
      
      return await createMockResponse(template);
    } catch (e) {
      console.log("[MOCK] 커스텀 엑셀 양식 상세 조회 실패:", e);
      throw e;
    }
  },

  // 커스텀 엑셀 양식 생성
  async createCustomExcelTemplate({ commit }, params) {
    try {
      console.log(`[MOCK] 엑셀 양식 생성:`, params);
      
      const { setting_name, column_settings } = params;
      
      if (!setting_name || !column_settings) {
        throw new Error("setting_name and column_settings are required");
      }
      
      const newTemplate = addMockTemplate({
        setting_name,
        column_settings
      });
      
      return await createMockResponse(newTemplate);
    } catch (e) {
      console.log("[MOCK] 커스텀 엑셀 양식 생성 실패:", e);
      throw e;
    }
  },

  // 커스텀 엑셀 양식 수정
  async updateCustomExcelTemplate({ commit }, { customSettingId, params }) {
    try {
      console.log(`[MOCK] 엑셀 양식 수정: ${customSettingId}`, params);
      
      const { setting_name, column_settings } = params;
      
      const updatedTemplate = updateMockTemplate(customSettingId, {
        setting_name,
        column_settings
      });
      
      if (!updatedTemplate) {
        throw new Error(`Template with ID '${customSettingId}' not found`);
      }
      
      return await createMockResponse(updatedTemplate);
    } catch (e) {
      console.log("[MOCK] 커스텀 엑셀 양식 수정 실패:", e);
      throw e;
    }
  },

  // 커스텀 엑셀 양식 삭제
  async deleteCustomExcelTemplate({ commit }, customSettingId) {
    try {
      console.log(`[MOCK] 엑셀 양식 삭제: ${customSettingId}`);
      
      const deletedTemplate = deleteMockTemplate(customSettingId);
      
      if (!deletedTemplate) {
        throw new Error(`Template with ID '${customSettingId}' not found`);
      }
      
      return await createMockResponse({
        custom_setting_id: customSettingId,
        message: "양식이 성공적으로 삭제되었습니다."
      });
    } catch (e) {
      console.log("[MOCK] 커스텀 엑셀 양식 삭제 실패:", e);
      throw e;
    }
  },

  // 커스텀 엑셀 양식 일괄 삭제
  async bulkDeleteCustomExcelTemplates({ commit }, templateIds) {
    try {
      console.log(`[MOCK] 엑셀 양식 일괄 삭제:`, templateIds);
      
      if (!Array.isArray(templateIds) || templateIds.length === 0) {
        throw new Error("template_ids array is required and must not be empty");
      }
      
      const deletedTemplates = bulkDeleteMockTemplates(templateIds);
      
      return await createMockResponse({
        deleted_count: deletedTemplates.length,
        custom_setting_ids: templateIds,
        message: "선택된 양식들이 성공적으로 삭제되었습니다."
      });
    } catch (e) {
      console.log("[MOCK] 커스텀 엑셀 양식 일괄 삭제 실패:", e);
      throw e;
    }
  }
};

export default mockActions;
